"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _YearMenuItem = _interopRequireDefault(require("../YearMenuItem"));

var _withStyles = _interopRequireDefault(require("../../../utils/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var YearMenu = function YearMenu(_ref) {
  var classes = _ref.classes,
      activeViewYear = _ref.activeViewYear,
      selectYear = _ref.selectYear,
      props = _objectWithoutProperties(_ref, ["classes", "activeViewYear", "selectYear"]);

  var currentYear = (0, _moment["default"])().year();
  var emptyYearsArr = new Array(111).fill(); // 100 years back, 1 current year, 10 years forward = 111

  return _react["default"].createElement("div", _extends({
    className: classes.root
  }, props), emptyYearsArr.map(function (item, i) {
    var year = currentYear - 100 + i;
    var itemProps = {
      year: year,
      currentYear: currentYear,
      isActiveYear: year === activeViewYear,
      selectYear: selectYear
    };
    return _react["default"].createElement(_YearMenuItem["default"], _extends({
      key: year
    }, itemProps));
  }));
};

YearMenu.propTypes = {
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  activeViewYear: _propTypes["default"].number.isRequired,
  selectYear: _propTypes["default"].func.isRequired
};

var _default = (0, _withStyles["default"])(_styles["default"])(YearMenu);

exports["default"] = _default;